
import { ReallySticky } from "@/global-scripts/ReallySticky.ts";
import { Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import PrintBasketModule from "@/store/modules/PrintBasketModule";
import { Route } from "vue-router";

import $ from "jquery";
import ContentModule from "@/store/modules/ContentModule";
import SearchModule from "@/store/modules/SearchModule";

const PULSATE_DURATION = 2500;
const PULSATE_DURATION_ONCE = 1250;

@Component
export default class PrintBasketButton extends Vue {
  readonly printBasketModule = getModule(PrintBasketModule, this.$store);
  readonly searchModule = getModule(SearchModule, this.$store);

  pulseTimer: ReturnType<typeof setTimeout> | undefined = undefined;
  pulsating = false;
  reallySticky!: ReallySticky;
  printBasketElement: any;

  get count(): number {
    return this.printBasketModule.printBasketCount;
  }

  get componentClasses(): string {
    const classes = [];

    if (this.pulsating) {
      classes.push("is-pulsating");
    }
    if (this.searchModule.searchModalOpen) {
      classes.push("search-open");
    }

    if (this.count >= this.$config.topicBasketLimit) {
      classes.push("limit-reached");
    } else if (this.count / this.$config.topicBasketLimit >= 0.8) {
      classes.push("limit-warning");
    }

    return classes.join(" ");
  }

  openPrintBasket() {
    this.printBasketModule.setPrintBasketOpen(true);
  }

  getStickyOffset(): number {
    const isCategoriesPage = $(".categories-page").length > 0;
    if ($(window).width() < 768) {
      return 20;
    } else if ($(window).width() < 992) {
      return 20 * 2 + this.printBasketElement.height();
    } else {
      return isCategoriesPage ? 0 : 20 + this.printBasketElement.height();
    }
  }

  pulsate(duration: number) {
    clearTimeout(this.pulseTimer);
    this.pulseTimer = setTimeout(() => {
      this.pulsating = true;
      this.pulseTimer = setTimeout(() => {
        this.pulsating = false;
      }, duration);
    }, 250);
  }

  @Watch("$route")
  onRouteChange(to: Route, from: Route) {
    if (to.name === "Start" || from.name === "Start") {
      this.reallySticky.opts.offset = this.getStickyOffset();
      this.reallySticky.update();
    }
  }

  @Watch("count")
  onCountChange(to: number, from: number) {
    if (from === 0 && to === 1) {
      this.pulsate(PULSATE_DURATION);
    } else if (to > from) {
      this.pulsate(PULSATE_DURATION_ONCE);
    }
  }

  created() {
    this.$nextTick(() => {
      this.printBasketElement = $(".PrintBasketButton");

      this.reallySticky = new ReallySticky(this.printBasketElement, {
        containerSel: ".page > .main-wrapper",
        fixedTopNavSel: ".top-nav",
        offset: this.getStickyOffset(),
        breakpoint: 768,
      });

      $(window).on("scroll", () => {
        this.reallySticky.update();
      });
      $(window).on("resize", () => {
        this.reallySticky.update();
      });
    });
  }
}
